import { render, staticRenderFns } from "./ogwhatsapp.vue?vue&type=template&id=47870274&scoped=true"
import script from "./ogwhatsapp.vue?vue&type=script&lang=js"
export * from "./ogwhatsapp.vue?vue&type=script&lang=js"
import style0 from "./ogwhatsapp.vue?vue&type=style&index=0&id=47870274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47870274",
  null
  
)

export default component.exports